import React, { FunctionComponent } from 'react';
import {ClassBuilder, Page} from 'b302-frontend-library';

interface Props {
    children: any;
    className?: string;
}

const FilterPage: FunctionComponent<Props> = ({ children, className }) => {

    const getClassName = () => {
        return ClassBuilder.createClass('filter-page')
            .addIf(className, className)
            .build();
    };

    return (
        <Page className={getClassName()}>
            { children }
        </Page>
    );
}

export default FilterPage;
